import React from 'react'
import s from './SubHeaderWithETAAndGoToItinerary.less'
import ETA from './ETA'
import GoToItineraryButton from './GoToItineraryButton'
import { useSelector } from 'react-redux'
import { withOnlyPE } from '../Device'
import { POI } from '../../store/search/location.types'
import { getSelectedLocation } from '../../store/location/location.selectors'
import { SPD_GEOENTITY_GOTO } from '../analytics/BiTagger'
import { PAGE_ADDRESS_NAME, PAGE_POI_NAME } from '../analytics/PageTagsService'

export default withOnlyPE(function SubHeaderWithETAAndGoToItinerary() {
  const location = useSelector(getSelectedLocation)

  return (
    <div className={s.SubHeaderWithETAAndGoToItinerary}>
      <div className={s.ETA}>
        <ETA />
      </div>
      <div className={s.buttonGoToAddress}>
        <GoToItineraryButton
          location={location}
          tagProps={{
            tagInfo: {
              ancrage: location.type === POI ? PAGE_POI_NAME : PAGE_ADDRESS_NAME
            }
          }}
          biProps={
            location &&
            location.type === 'poi' && {
              tagId: SPD_GEOENTITY_GOTO,
              params: { geoentity: location.id }
            }
          }
        />
      </div>
    </div>
  )
})
